import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormOctagonRotate: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-octagon-rotate"><path d="M12 2.25L18.8943 5.10571L21.75 12L18.8943 18.8943L12 21.75L5.10571 18.8943L2.25 12L5.10571 5.10571L12 2.25Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFormOctagonRotate;
